import { Component, OnInit } from '@angular/core';
import { TranslocoService } from '@jsverse/transloco';
import { CalendarCurrentMode, CalendarModes, ChangeMode, ColorFromId, LoaderService, Message, RestService } from '@stdoutsrl/design-kit';

@Component({
  selector: 'app-calendar',
  templateUrl: './calendar.component.html',
  styles: [],
  standalone: false,
})
export class EmployeeSheetComponent implements OnInit {
  constructor(
    private rest: RestService,
    private randomColorById: ColorFromId,
    private message: Message,
    private loader: LoaderService,
  ) {}

  showCalendar = false;
  isEditEvent = false;
  currentEventSelected: any = {};
  showModalEventDelete = false;
  mobileItems: any[] = [{ label: 'Prodotto', value: 'item.name' }];
  arrayEvents: any[] = [];
  arrayEventsLastWeek: any[] = [];
  isCalendarCreating = false;
  isCalendarCreatingHard = false;
  isCalendarCreatingRemainingTurns = false;
  isCalendarCreatingR2 = false;
  showSelectFilters = true;
  workDays: any[] = [];
  currentCalendarMode: CalendarCurrentMode = 'weekly';
  calendarModes: CalendarModes = {
    daily: {
      active: true,
    },
    weekly: {
      onStartScrollToH: 7,
      active: true,
      similarEventsFirstWFull: false,
      weeklyShowHoursMode: 'daily',
      weeklyHours: [
        0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19,
        20, 21, 22, 23,
      ],
    },
    monthly: {
      active: false,
    },
    annual: {
      active: false,
    },
  };
  eventsToCreateForFilling: any[] = [];
  completedHardEvents = 0;
  dateForApi = '';
  showModalEvent = false;
  date = '';
  currentDate = new Date();
  alerts: {
    h?: number;
    missingNumber?: number;
    m?: number;
    date?: Date;
    jobName?: string;
    jobId?: number;
    day?: number;
    endH?: number;
    endM?: number;
    type: number;
    desc?: string;
  }[] = [];
  specialAlerts: {
    h?: number;
    missingNumber?: number;
    m?: number;
    date?: Date;
    jobName?: string;
    jobId?: number;
    day?: number;
    endH?: number;
    endM?: number;
    type: number;
    desc?: string;
  }[] = [];
  completedAlert = 0;
  indexToCheck = 0;
  stores: any = [];
  selectedStore: any = {};
  employees: any[] = [];
  selectedEmployee: any = {};
  jobs: any[] = [];
  selectedJob: any = {};
  jobsEmployee: any[] = [];
  startDate = new Date();
  endDate = new Date();
  calendarStart = new Date().toISOString();
  calendarEnd = new Date().toISOString();
  calendarStartLastWeek = new Date().toISOString();
  calendarEndLastWeek = new Date().toISOString();
  employeesWorkedLastSunday: any[] = [];
  shift: any = {};
  showStart = false;
  showEnd = false;
  showModalCreateCalendar = false;
  showAlerts = false;
  creatingHardAlert = false;
  creatingRemainingHours = false;
  creatingRemainingHours2 = 0;
  loopDuration = 0;
  loopIndex = 0;
  lastFreeDay = 1;
  typeJobs = [
    'working',
    'permission',
    'special',
    'working_before',
    'hard_working',
    'working_hard_before',
    'working_before_no_sunday',
    'free',
  ];
  workingJobs = [
    'working',
    'working_before',
    'hard_working',
    'working_hard_before',
    'working_before_no_sunday',
  ];
  noWorkJobs = ['permission', 'special', 'free'];
  completeListOfEventsToCreate: any = [];
  indexCheckEventsFilling = 0;
  ngOnInit(): void {
    this.getStores();
    this.getJobs();
    this.getWeekBounds(); // ottiene le data precise per inizio e fine settimana
  }

  resetFilters() {
    this.selectedEmployee = {};
    this.selectedJob = {};
    this.showSelectFilters = false;
    setTimeout(() => {
      this.showSelectFilters = true;
    }, 0);
    this.getCalendarEvents();
  }

  getWeekBounds(myDate?: any) {
    let date = myDate ? new Date(myDate) : new Date();
    const currentDate = new Date(date);
    const dayOfWeek = currentDate.getDay();
    const diffToMonday = dayOfWeek === 0 ? -6 : 1 - dayOfWeek;
    const firstDay = new Date(currentDate);
    firstDay.setDate(currentDate.getDate() + diffToMonday);
    const lastDay = new Date(firstDay);
    lastDay.setDate(firstDay.getDate() + 6);
    this.calendarStart = firstDay.toISOString();
    this.calendarEnd = lastDay.toISOString();
    this.calendarStartLastWeek = new Date(
      firstDay.setDate(firstDay.getDate() - 7),
    ).toISOString();
    this.calendarEndLastWeek = new Date(
      lastDay.setDate(lastDay.getDate() - 7),
    ).toISOString();
  }

  changeMode(event: ChangeMode) {
    this.currentCalendarMode = event.mode;
    switch (event.mode) {
      case 'daily':
        this.getNewEventsDay(event.calendar);
        break;
      case 'weekly':
        this.getNewEventsWeek(event.calendar);
        break;
      case 'monthly':
        this.getNewEventsWeek(event.calendar);
        break;

      default:
        break;
    }
  }

  getNewEventsDay(event: any) {
    const firstDay = new Date(event.firstDate);
    const lastDay = new Date(event.lastDate);
    this.calendarStart = firstDay.toISOString();
    this.calendarEnd = lastDay.toISOString();
    this.getCalendarEvents();
  }

  moveEvent(event: any) {
    let startTime = `${new Date(event.start).getHours()}:${new Date(event.start).getMinutes()}:00`;
    let endTime = `${new Date(event.end).getHours()}:${new Date(event.end).getMinutes()}:00`;
    let myEvent = this.arrayEvents.find((shift: any) => shift.id == event.id);
    let params = {
      startTime: startTime,
      endTime: endTime,
      date: new Date(event.start).toISOString(),
    };
    this.loader.on();
    this.rest.patch(`/shift/${myEvent.id}`, params).subscribe({
      next: (value) => {
        this.loader.off(true);
        this.getCalendarEvents();
      },
    });
  }

  adjustDateSelect(event: any, name: string) {
    const [day, month, year] = this.date
      .split('/')
      .map((part) => parseInt(part, 10));
    let newDate = new Date(
      year,
      month - 1,
      day,
      parseInt(event.h),
      parseInt(event.m),
    );
    this.shift[name] = newDate;
  }

  getStores() {
    this.loader.on();
    this.rest.get('/store?options={%22page%22:1,%22filters%22:[]}').subscribe({
      next: (value: any) => {
        this.stores = value.data;
        this.loader.off(true);
      },
    });
  }

  shuffle(array: any[]) {
    return array.sort(() => Math.random() - 0.5);
  }

  getEmployees() {
    this.loader.on();
    let options = { page: 1, filters: [], limit: 99 };
    this.rest
      .get(
        `/employee?options=${JSON.stringify(options)}&storeIds=[${this.selectedStore.id}]`,
      )
      .subscribe({
        next: (value: any) => {
          this.employees = this.shuffle(value.data).map((res: any, index: number) => {
            res.completeName = res.firstName + ' ' + res.lastName;
            res.freeDay = (index % 6) + 1;
            return res;
          });
          let totalHTEST = 0;
          this.employees.forEach((element) => {
            totalHTEST = totalHTEST + parseFloat(element.maxWeekHours);
          });
          //shuffle da riattivare
          // this.shuffle(this.employees);
          this.loader.off(true);
        },
      });
  }
  getJobs() {
    this.loader.on();
    let options = {
      page: 1,
      filters: [],
    };
    this.rest.get(`/job?options=${JSON.stringify(options)}`).subscribe({
      next: (value: any) => {
        this.jobs = value;
        this.loader.off(true);
      },
    });
  }

  changeEventTime(event: any) {}

  changeSelect(event: any, name: string) {
    let myThis: any = this;
    myThis[name] = event;
    if (this.selectedStore.id) {
      if (name == 'selectedStore') {
        this.getStoreDetails();
        this.getEmployees();
      } else {
        this.getCalendarEvents();
      }
    }
  }

  getStoreDetails() {
    this.loader.on();
    this.rest.get(`/store/${this.selectedStore.id}/timetables`).subscribe({
      next: (value: any) => {
        this.workDays = value.map((res: any) => {
          if (res.timeStart) {
            let mySplittedStart = res.timeStart.split(':');
            let mySplittedEnd = res.timeEnd.split(':');
            res.openH = parseInt(mySplittedStart[0]);
            res.openM = parseInt(mySplittedStart[1]);
            res.closeH = parseInt(mySplittedEnd[0]);
            res.closeM = parseInt(mySplittedEnd[1]);
          }
          if (res.mediumStart) {
            let mySplittedStart = res.mediumStart.split(':');
            let mySplittedEnd = res.mediumEnd.split(':');
            res.mediumStartH = parseInt(mySplittedStart[0]);
            res.mediumStartM = parseInt(mySplittedStart[1]);
            res.mediumEndH = parseInt(mySplittedEnd[0]);
            res.mediumEndM = parseInt(mySplittedEnd[1]);
          } else {
            res.mediumStartH = 8;
            res.mediumStartM = 30;
            res.mediumEndH = 8;
            res.mediumEndM = 30;
          }
          if (res.hardStart) {
            let mySplittedStart = res.hardStart.split(':');
            let mySplittedEnd = res.hardEnd.split(':');
            res.hardStartH = parseInt(mySplittedStart[0]);
            res.hardStartM = parseInt(mySplittedStart[1]);
            res.hardEndH = parseInt(mySplittedEnd[0]);
            res.hardEndM = parseInt(mySplittedEnd[1]);
          } else {
            res.hardStartH = 8;
            res.hardStartM = 30;
            res.hardEndH = 8;
            res.hardEndM = 30;
          }
          return res;
        });
        // let day1 = this.workDays.find((res: any) => res.day == 1) ? this.workDays.find((res: any) => res.day == 1) : {
        //   day: 1,
        //   openH: 8,
        //   openM: 30,
        //   closeH: 20,
        //   closeM: 30,
        //   mediumStartH: 13,
        //   mediumEndH: 16,
        //   mediumStartM: 0,
        //   mediumEndM: 30,
        //   hardStartH: 16,
        //   hardEndH: 20,
        //   hardStartM: 30,
        //   hardEndM: 30
        // }
        // let day2 = this.workDays.find((res: any) => res.day == 2) ? this.workDays.find((res: any) => res.day == 2) : {
        //   day: 2,
        //   openH: 8,
        //   openM: 30,
        //   closeH: 20,
        //   closeM: 30,
        //   mediumStartH: 13,
        //   mediumEndH: 16,
        //   mediumStartM: 0,
        //   mediumEndM: 30,
        //   hardStartH: 16,
        //   hardEndH: 20,
        //   hardStartM: 30,
        //   hardEndM: 30
        // }
        // let day3 = this.workDays.find((res: any) => res.day == 3) ? this.workDays.find((res: any) => res.day == 3) : {
        //   day: 3,
        //   openH: 8,
        //   openM: 30,
        //   closeH: 20,
        //   closeM: 30,
        //   mediumStartH: 13,
        //   mediumEndH: 16,
        //   mediumStartM: 0,
        //   mediumEndM: 30,
        //   hardStartH: 16,
        //   hardEndH: 20,
        //   hardStartM: 30,
        //   hardEndM: 30
        // }
        // let day4 = this.workDays.find((res: any) => res.day == 4) ? this.workDays.find((res: any) => res.day == 4) : {
        //   day: 4,
        //   openH: 8,
        //   openM: 30,
        //   closeH: 20,
        //   closeM: 30,
        //   mediumStartH: 13,
        //   mediumEndH: 16,
        //   mediumStartM: 0,
        //   mediumEndM: 30,
        //   hardStartH: 16,
        //   hardEndH: 20,
        //   hardStartM: 30,
        //   hardEndM: 30
        // }
        // let day5 = this.workDays.find((res: any) => res.day == 5) ? this.workDays.find((res: any) => res.day == 5) : {
        //   day: 5,
        //   openH: 8,
        //   openM: 30,
        //   closeH: 20,
        //   closeM: 30,
        //   mediumStartH: 13,
        //   mediumEndH: 16,
        //   mediumStartM: 0,
        //   mediumEndM: 30,
        //   hardStartH: 16,
        //   hardEndH: 20,
        //   hardStartM: 30,
        //   hardEndM: 30
        // }
        // let day6 = this.workDays.find((res: any) => res.day == 6) ? this.workDays.find((res: any) => res.day == 6) : {
        //   day: 6,
        //   openH: 8,
        //   openM: 30,
        //   closeH: 20,
        //   closeM: 30,
        //   mediumStartH: 13,
        //   mediumEndH: 16,
        //   mediumStartM: 0,
        //   mediumEndM: 30,
        //   hardStartH: 16,
        //   hardEndH: 20,
        //   hardStartM: 30,
        //   hardEndM: 30
        // }
        // let day0 :any= this.workDays.find((res: any) => res.day == 0) ? this.workDays.find((res: any) => res.day == 0) : {
        //   day: 0,
        //   openH: 8,
        //   openM: 30,
        //   closeH: 20,
        //   closeM: 30,
        //   mediumStartH: 13,
        //   mediumEndH: 16,
        //   mediumStartM: 0,
        //   mediumEndM: 30,
        //   hardStartH: 16,
        //   hardEndH: 20,
        //   hardStartM: 30,
        //   hardEndM: 30
        // }
        // this.workDays = [day1,day2,day3,day4,day5,day6,day0]
        this.getCalendarEvents();
        this.loader.off(true);
      },
    });
  }

  changeSelectShift(event: any, name: string) {
    if (name == 'selectedEmployee') {
      let nonWorkingJobs = this.jobs.filter((job: any) =>
        this.noWorkJobs.includes(job.jobType),
      );
      this.jobsEmployee = [...event.jobs, ...nonWorkingJobs];
    }
    this.shift[name] = event.id;
    if (name == 'selectedEmployee') {
      let sec = this.shift['selectedEmployee'];
      this.shift['selectedEmployee'] = null;
      setTimeout(() => {
        this.shift['selectedEmployee'] = sec;
      }, 0);
    }
  }

  confirmModal() {
    this.showModalEvent = false;
    this.loader.on();

    let params = {
      employeeId: this.shift.selectedEmployee,
      jobId: this.shift.selectedJob,
      startTime: this.shift.startDateShow + ':00',
      endTime: this.shift.endDateShow + ':00',
      date: new Date(this.shift.startDate).toISOString(),
      storeId: this.selectedStore.id,
      type: 'CONTINUATO',
      filledTime:
        (new Date(this.shift.endDate).getTime() -
          new Date(this.shift.startDate).getTime()) /
        (1000 * 60 * 60),
    };
    this.rest.post('/shift', params).subscribe({
      next: (value) => {
        this.getCalendarEvents();
        this.loader.off(true);
      },
    });
  }

  getCalendarEvents() {
    //Viene chiamata ogni volta che si deve rigenerare il calendario per un motivo o un'altro oppure anche se servono i giorni per la seconda fate di creazione turni con relativi alert
    this.loader.on();
    this.rest
      .get(
        `/shift/range?storeId=${this.selectedStore.id}&startDate=${this.calendarStart}&endDate=${this.calendarEnd}${this.selectedEmployee.id ? '&employeeId=' + this.selectedEmployee.id : ''}${this.selectedJob.id ? '&jobId=' + this.selectedJob.id : ''}`,
      )
      .subscribe({
        next: (value: any) => {
          this.arrayEvents = value.map((event: any) => ({
            name: `${event.employee.firstName} ${event.employee.lastName} - ${this.jobs[event.jobId - 1].name}`,
            employee: 'Santino',
            dateStart: new Date(event.date + 'T' + event.startTime),
            startDate: new Date(event.date + 'T' + event.startTime),
            endDate: new Date(event.date + 'T' + event.endTime),
            tDateStart: new Date(
              new Date(event.date + 'T' + event.startTime),
            ).getTime(),
            dateEnd: new Date(event.date + 'T' + event.endTime),
            tDateEnd: new Date(
              new Date(event.date + 'T' + event.endTime),
            ).getTime(),
            completeEvent: event,
            bgColor: this.randomColorById.generateColorFromId(
              this.jobs[event.jobId - 1].id + this.jobs[event.jobId - 1].name,
            ),
            ...event,
          }));
          setTimeout(() => {
            this.getCalendarEventsLastWeek();
            // Dopo mezzo secondo messo per essere sicuro che il resto sia finito
            this.loader.off(true);
          }, 500);
        },
        error: () => {},
      });
    // ottiene eventi scorsa settimana per non farlo lavorare due domeniche di file
  }

  getCalendarEventsLastWeek() {
    this.loader.on();
    this.rest
      .get(
        `/shift/range?storeId=${this.selectedStore.id}&startDate=${this.calendarStartLastWeek}&endDate=${this.calendarEndLastWeek}${this.selectedEmployee.id ? '&employeeId=' + this.selectedEmployee.id : ''}${this.selectedJob.id ? '&jobId=' + this.selectedJob.id : ''}`,
      )
      .subscribe({
        next: (value: any) => {
          this.arrayEventsLastWeek = value.map((event: any) => ({
            name: `${event.employee.firstName} ${event.employee.lastName} - ${this.jobs[event.jobId - 1].name}`,
            employee: 'Santino',
            dateStart: new Date(event.date + 'T' + event.startTime),
            startDate: new Date(event.date + 'T' + event.startTime),
            endDate: new Date(event.date + 'T' + event.endTime),
            tDateStart: new Date(
              new Date(event.date + 'T' + event.startTime),
            ).getTime(),
            dateEnd: new Date(event.date + 'T' + event.endTime),
            tDateEnd: new Date(
              new Date(event.date + 'T' + event.endTime),
            ).getTime(),
            completeEvent: event,
            bgColor: this.randomColorById.generateColorFromId(
              this.jobs[event.jobId - 1].id + this.jobs[event.jobId - 1].name,
            ),
            ...event,
          }));
          this.employeesWorkedLastSunday = JSON.parse(
            JSON.stringify(this.employees),
          ).filter((employee: any) => {
            let workedSunday = false;
            this.arrayEventsLastWeek
              .filter((event: any) => new Date(event.startDate).getDay() == 0)
              .forEach((event: any) => {
                if (employee.id == event.employee.id) {
                  workedSunday = true;
                }
              });
            return workedSunday;
          });
          setTimeout(() => {
            this.showCalendar = true;
            this.checksCalendarIsComplete();
          }, 500);
          this.loader.off(true);
        },
        error: () => {},
      });
  }

  getEventTime(timestamp: number): string {
    const date = new Date(timestamp);
    const hours = date.getHours().toString().padStart(2, '0');
    const minutes = date.getMinutes().toString().padStart(2, '0');
    return `${hours}:${minutes}`;
  }

  manageElementsEvent(event: any) {
    this.currentEventSelected = event;
    this.showModalEventDelete = true;
  }

  dateSelect(dayCalendar: any) {
    this.isEditEvent = false;
    const date = new Date(dayCalendar.date);
    const day = date.getDate().toString().padStart(2, '0');
    const month = (date.getMonth() + 1).toString().padStart(2, '0');
    const year = date.getFullYear();
    const formattedDate = `${day}/${month}/${year}`;
    this.dateForApi = `${year}-${month}-${day}`;
    this.currentEventSelected = {};
    this.showModalEvent = true;
    this.date = formattedDate;
    this.currentDate = date;
    this.showModalEvent = true;
  }

  getNewEventsWeek(event: any) {
    this.getWeekBounds(event.firstDate);
    this.getCalendarEvents();
  }

  // getNewEventsMonth(event: any) { }

  checksCalendarIsComplete() {
    this.alerts = [];
    this.getAlertMaxH();
    this.getAlertMaxHWeekly();
    this.getAlertMissingRole();
    if (
      !this.isCalendarCreating &&
      !this.isCalendarCreatingHard &&
      !this.creatingRemainingHours
    ) {
      this.getAlertRemainingHours();
    }
    this.creatingHardAlert = true;
    this.indexToCheck = 0;
    this.meltAlerts();
  }

  getAlertRemainingHours() {
    this.employees.forEach((employee, index) => {
      let filteredEvents = this.arrayEvents.filter((event) => {
        return event.employeeId == employee.id;
      });
      let totalWorkedH = 0;
      filteredEvents.forEach((event: any) => {
        totalWorkedH =
          totalWorkedH + (event.tDateEnd - event.tDateStart) / 1000 / 3600;
      });
      employee.totalWorkedHWeek = totalWorkedH;
      if (totalWorkedH < parseInt(employee.maxWeekHours)) {
        this.alerts.push({
          type: 6,
          desc:
            employee.completeName +
            ' rimangono ' +
            (parseInt(employee.maxWeekHours) - totalWorkedH) +
            ' ore questa settimana.',
        });
      }
    });
  }

  getAlertMaxH() {
    let currentDate = new Date(this.currentDate);
    let currentDay = currentDate.getDate();
    let currentWeekday = currentDate.getDay();
    const firstDayOfWeek = new Date(currentDate);
    firstDayOfWeek.setDate(currentDay - (currentWeekday - 1));
    firstDayOfWeek.setSeconds(0);
    firstDayOfWeek.setMilliseconds(0);

    this.employees.forEach((employee, index) => {
      this.workDays.forEach((day) => {
        let filteredEvents = this.arrayEvents.filter((event) => {
          return (
            event.employeeId == employee.id &&
            new Date(event.startDate).getDay() == day.day
          );
        });
        if (filteredEvents.length > 0) {
          let totalHWorked = 0;
          filteredEvents.forEach((event) => {
            let workTime =
              new Date(event.endDate).getTime() -
              new Date(event.startDate).getTime();
            workTime = workTime / 1000 / 60 / 60;
            totalHWorked = totalHWorked + workTime;
          });
          this.employees[index]['totalHWorked' + day.day] = totalHWorked;
          //dssdds
          if (totalHWorked > employee.maxDayHours) {
            this.alerts.push({
              type: 2,
              day: day.day,
              desc:
                employee.completeName +
                ' è in eccesso di  ' +
                (totalHWorked - employee.maxDayHours) +
                ' ore',
            });
          }
        } else {
          this.employees[index]['totalHWorked' + day.day] = 0;
        }
      });
    });
  }

  getAlertMaxHWeekly() {
    this.employees.forEach((employee, index) => {
      let filteredEvents = this.arrayEvents.filter((event) => {
        return event.employeeId == employee.id;
      });
      let totalWorkedH = 0;
      filteredEvents.forEach((event: any) => {
        totalWorkedH =
          totalWorkedH + (event.tDateEnd - event.tDateStart) / 1000 / 3600;
      });
      employee.totalWorkedHWeek = totalWorkedH;
      if (totalWorkedH > parseInt(employee.maxWeekHours)) {
        this.alerts.push({
          type: 3,
          desc:
            employee.completeName +
            ' è in eccesso di  ' +
            (totalWorkedH - parseInt(employee.maxWeekHours)) +
            ' ore questa settimana.',
        });
      }
    });
  }

  getAlertHard() {
    // this.creatingHardAlert = false
    // this.meltAlerts()
    // return false
    const minutes30 = 1000 * 60 * 30;
    let currentDate = new Date(this.currentDate);
    let currentDay = currentDate.getDate();
    let currentWeekday = currentDate.getDay();
    const firstDayOfWeek = new Date(currentDate);
    firstDayOfWeek.setDate(currentDay - (currentWeekday - 1));
    firstDayOfWeek.setSeconds(0);
    firstDayOfWeek.setMilliseconds(0);
    let listHardTimes: any[] = [];
    this.workDays.forEach((day: any) => {
      if (day.highRange) {
        let highRange = JSON.parse(day.highRange);
        highRange.forEach((high: any) => {
          let myDayToAdd = JSON.parse(JSON.stringify(day));
          myDayToAdd.timeStart = high.timeStart;
          myDayToAdd.timeEnd = high.timeEnd;
          myDayToAdd.openH = parseInt(high.timeStart.split(':')[0]);
          myDayToAdd.openM = parseInt(high.timeStart.split(':')[1]);
          myDayToAdd.closeH = parseInt(high.timeEnd.split(':')[0]);
          myDayToAdd.closeM = parseInt(high.timeEnd.split(':')[1]);
          listHardTimes.push(myDayToAdd);
        });
      }
    });

    listHardTimes.forEach((day) => {
      let numberOfSlots =
        (day.closeH * 60 * 60 * 1000 +
          day.closeM * 60 * 1000 -
          (day.openH * 60 * 60 * 1000 + day.openM * 60 * 1000)) /
        minutes30;
      let myDay = new Date(firstDayOfWeek).setDate(
        new Date(firstDayOfWeek).getDate() + (day.day == 0 ? 7 : day.day) - 1,
      );
      for (let index = 0; index < numberOfSlots; index++) {
        let foundEvents = this.arrayEvents.filter((event: any) => {
          let date: any = new Date(
            new Date(myDay).setHours(day.openH + Math.ceil(index / 2)),
          ).setMinutes(30 * ((index + 1) % 2));
          date = new Date(
            new Date(this.calendarStart).setDate(
              new Date(this.calendarStart).getDate() +
                (new Date(date).getDay() - 1 == -1
                  ? 6
                  : new Date(date).getDay() - 1),
            ),
          ).setHours(23, 59, 59, 59);

          let openHValue = day.openH + day.openM / 60 + index * 0.5;
          let eventStartHValue =
            new Date(event.tDateStart).getHours() +
            new Date(event.tDateStart).getMinutes() / 60;
          let eventEndHValue =
            new Date(event.tDateEnd).getHours() +
            new Date(event.tDateEnd).getMinutes() / 60;

          return (
            event.job.jobType.includes('hard') &&
            openHValue >= eventStartHValue &&
            openHValue + 0.5 <= eventEndHValue &&
            new Date(event.startDate).getDay() == day.day &&
            new Date(event.startDate).getTime() <= date &&
            new Date(event.endDate).getTime() >
              new Date(new Date(date).setHours(0, 0, 0, 0)).getTime()
          );
        });

        if (foundEvents.length < 5) {
          let date = new Date(
            new Date(myDay).setHours(day.openH + Math.ceil(index / 2)),
          ).setMinutes(30 * ((index + 1) % 2));
          this.alerts.push({
            h:
              day.openH +
              Math.ceil((index - 1 + (day.openM == 30 ? 1 : 0)) / 2),
            m: 30 * ((index + (day.openM == 30 ? 1 : 0)) % 2),
            endH:
              day.openH + Math.ceil((index + (day.openM == 30 ? 1 : 0)) / 2),
            endM: 30 * ((index + 1 + (day.openM == 30 ? 1 : 0)) % 2),
            missingNumber: 5 - foundEvents.length,
            day: day.day,
            date: new Date(
              new Date(this.calendarStart).setDate(
                new Date(this.calendarStart).getDate() +
                  (new Date(date).getDay() - 1 == -1
                    ? 6
                    : new Date(date).getDay() - 1),
              ),
            ),
            type: 5,
          });
        }
      }
    });
    this.creatingHardAlert = false;
    this.meltAlerts();
  }

  getAlertMissingRole() {
    const minutes30 = 1000 * 60 * 30;
    let currentDate = new Date(this.currentDate);
    let currentDay = currentDate.getDate();
    let currentWeekday = currentDate.getDay();
    const firstDayOfWeek = new Date(currentDate);
    firstDayOfWeek.setDate(currentDay - (currentWeekday - 1));
    firstDayOfWeek.setSeconds(0);
    firstDayOfWeek.setMilliseconds(0);
    let totHoursNeedTest = 0;
    this.workDays.forEach((day) => {
      let numberOfSlots =
        (day.closeH * 60 * 60 * 1000 +
          day.closeM * 60 * 1000 -
          (day.openH * 60 * 60 * 1000 + day.openM * 60 * 1000)) /
        minutes30;
      this.jobs
        .filter(
          (job: any) =>
            this.workingJobs.includes(job.jobType) &&
            (day.day !== 0 || !job.jobType.includes('no_sunday')),
        )
        .forEach((job) => {
          totHoursNeedTest = totHoursNeedTest + numberOfSlots / 2;
          let listWorkingThisDays = this.workDays.filter(
            (myDay: any) => myDay.day == day.day,
          );
          let mappedListArray = listWorkingThisDays.map((myDay: any) =>
            parseInt(myDay.timeStart.slice(0, 2)),
          );
          let indexFirstDay = mappedListArray.indexOf(
            Math.min(...mappedListArray),
          );
          let firstOfTheDay = listWorkingThisDays[indexFirstDay];
          let isFirstOfTheDay = firstOfTheDay.timeStart == day.timeStart;
          let startBefore = job.jobType.includes('before') && day.day !== 0;
          let myDay = new Date(firstDayOfWeek).setDate(
            new Date(firstDayOfWeek).getDate() +
              (day.day == 0 ? 7 : day.day) -
              1,
          );
          for (
            let index = 0;
            index < numberOfSlots + (startBefore && isFirstOfTheDay ? 2 : 0);
            index++
          ) {
            let foundEvent = this.arrayEvents.find((event: any) => {
              let date: any = new Date(
                new Date(myDay).setHours(day.openH + Math.ceil(index / 2)),
              ).setMinutes(30 * ((index + 1) % 2));
              // old date = new Date(this.calendarStart).setDate(new Date(this.calendarStart).getDate() + ( (new Date(date).getDay() - 1) == -1 ? 6 : (new Date(date).getDay() - 1) ))
              date = new Date(
                new Date(this.calendarStart).setDate(
                  new Date(this.calendarStart).getDate() +
                    (new Date(date).getDay() - 1 == -1
                      ? 6
                      : new Date(date).getDay() - 1),
                ),
              ).setHours(23, 59, 59, 59);
              return (
                event.job.name == job.name &&
                new Date(event.startDate).getDay() == day.day &&
                new Date(event.startDate).getTime() <= date &&
                new Date(event.endDate).getTime() >
                  new Date(new Date(date).setHours(0, 0, 0, 0)).getTime()
              );
            });

            if (!foundEvent) {
              let date = new Date(
                new Date(myDay).setHours(day.openH + Math.ceil(index / 2)),
              ).setMinutes(30 * ((index + 1) % 2));
              this.alerts.push({
                h:
                  day.openH -
                  (startBefore && isFirstOfTheDay ? 1 : 0) +
                  Math.ceil((index - 1 + (day.openM == 30 ? 1 : 0)) / 2),
                m: 30 * ((index + (day.openM == 30 ? 1 : 0)) % 2),
                endH:
                  day.openH -
                  (startBefore && isFirstOfTheDay ? 1 : 0) +
                  Math.ceil((index + (day.openM == 30 ? 1 : 0)) / 2),
                endM: 30 * ((index + 1 + (day.openM == 30 ? 1 : 0)) % 2),
                jobName: job.name,
                jobId: job.id,
                day: day.day,
                date: new Date(
                  new Date(this.calendarStart).setDate(
                    new Date(this.calendarStart).getDate() +
                      (new Date(date).getDay() - 1 == -1
                        ? 6
                        : new Date(date).getDay() - 1),
                  ),
                ),
                type: 1,
              });
            }
          }
        });
    });
  }

  specialMeltAlerts() {
    if (this.indexToCheck + 1 < this.specialAlerts.length) {
      if (this.specialAlerts[this.indexToCheck].type == 1) {
        let endH = this.specialAlerts[this.indexToCheck].endH;
        let endM = this.specialAlerts[this.indexToCheck].endM;
        let job = this.specialAlerts[this.indexToCheck].jobName;
        let day = this.specialAlerts[this.indexToCheck].day;
        let startH = this.specialAlerts[this.indexToCheck + 1].h;
        let startM = this.specialAlerts[this.indexToCheck + 1].m;
        let jobNext = this.specialAlerts[this.indexToCheck + 1].jobName;
        let dayNext = this.specialAlerts[this.indexToCheck + 1].day;
        if (
          startH == endH &&
          endM == startM &&
          job == jobNext &&
          day == dayNext
        ) {
          this.specialAlerts[this.indexToCheck].endH =
            this.specialAlerts[this.indexToCheck + 1].endH;
          this.specialAlerts[this.indexToCheck].endM =
            this.specialAlerts[this.indexToCheck + 1].endM;
          this.specialAlerts.splice(this.indexToCheck + 1, 1);
          this.specialMeltAlerts();
        } else {
          this.indexToCheck = this.indexToCheck + 1;
          this.specialMeltAlerts();
        }
      } else {
        this.indexToCheck = this.indexToCheck + 1;
        this.specialMeltAlerts();
      }
    }
  }

  meltAlerts() {
    if (this.indexToCheck + 1 < this.alerts.length) {
      if (this.alerts[this.indexToCheck].type == 1) {
        let endH = this.alerts[this.indexToCheck].endH;
        let endM = this.alerts[this.indexToCheck].endM;
        let job = this.alerts[this.indexToCheck].jobName;
        let day = this.alerts[this.indexToCheck].day;
        let startH = this.alerts[this.indexToCheck + 1].h;
        let startM = this.alerts[this.indexToCheck + 1].m;
        let jobNext = this.alerts[this.indexToCheck + 1].jobName;
        let dayNext = this.alerts[this.indexToCheck + 1].day;
        if (
          startH == endH &&
          endM == startM &&
          job == jobNext &&
          day == dayNext
        ) {
          this.alerts[this.indexToCheck].endH =
            this.alerts[this.indexToCheck + 1].endH;
          this.alerts[this.indexToCheck].endM =
            this.alerts[this.indexToCheck + 1].endM;
          this.alerts.splice(this.indexToCheck + 1, 1);
          this.meltAlerts();
        } else {
          this.indexToCheck = this.indexToCheck + 1;
          this.meltAlerts();
        }
      } else {
        if (this.alerts[this.indexToCheck].type == 5) {
          let endH = this.alerts[this.indexToCheck].endH;
          let endM = this.alerts[this.indexToCheck].endM;
          let job = this.alerts[this.indexToCheck].jobName;
          let day = this.alerts[this.indexToCheck].day;
          let startH = this.alerts[this.indexToCheck + 1].h;
          let startM = this.alerts[this.indexToCheck + 1].m;
          let missingNumber = this.alerts[this.indexToCheck].missingNumber;
          let jobNext = this.alerts[this.indexToCheck + 1].jobName;
          let dayNext = this.alerts[this.indexToCheck + 1].day;
          let missingNumberNext =
            this.alerts[this.indexToCheck + 1].missingNumber;
          if (
            startH == endH &&
            endM == startM &&
            job == jobNext &&
            day == dayNext &&
            missingNumber == missingNumberNext
          ) {
            this.alerts[this.indexToCheck].endH =
              this.alerts[this.indexToCheck + 1].endH;
            this.alerts[this.indexToCheck].endM =
              this.alerts[this.indexToCheck + 1].endM;
            this.alerts.splice(this.indexToCheck + 1, 1);
            this.meltAlerts();
          } else {
            this.indexToCheck = this.indexToCheck + 1;
            this.meltAlerts();
          }
        } else {
          this.indexToCheck = this.indexToCheck + 1;
          this.meltAlerts();
        }
      }
    } else {
      //vengono rifatti diversi giri in questa sequenza, creazione tutti gli eventi normali, creazione tutti gli eventi di fascia alta, uso ore rimanenti
      if (this.creatingHardAlert) {
        this.getAlertHard();
      } else {
        if (this.isCalendarCreatingHard) {
          this.isCalendarCreatingHard = false;
          this.loader.off(true);
          this.loopCreateAllSuggestion();
        }
        if (this.isCalendarCreating) {
          this.isCalendarCreating = false;
          this.isCalendarCreatingHard = true;
          this.loader.off(true);
          this.loopCreateAllSuggestion();
        }

        if (this.creatingRemainingHours) {
          this.isCalendarCreating = false;
          this.isCalendarCreatingHard = false;
          this.creatingRemainingHours = false;
          this.creatingRemainingHours2 = 50;
          this.useRemainingHours3();
        }
      }
    }
  }

  logRemainingHours() {
    this.employees.forEach((employee: any, employeeIndex) => {
      console.log(
        employee,
        parseFloat(employee.maxWeekHours),
        employee.totalWorkedHWeek,
      );
      // if (parseFloat(employee.maxWeekHours) > employee.totalWorkedHWeek) {
      //   console.log(
      //     employee,
      //     parseFloat(employee.maxWeekHours),
      //     employee.totalWorkedHWeek,
      //   );
      // }
      // if (parseFloat(employee.maxWeekHours) < employee.totalWorkedHWeek) {
      //   console.log(
      //     employee,
      //     parseFloat(employee.maxWeekHours),
      //     employee.totalWorkedHWeek,
      //   );
      // }
    });
  }

  useRemainingHours3() {
    let currentDate = new Date(this.calendarStart);
    let currentDay = currentDate.getDate();
    let currentWeekday = currentDate.getDay();
    const firstDayOfWeek = new Date(currentDate);
    firstDayOfWeek.setDate(currentDay - (currentWeekday - 1));
    firstDayOfWeek.setSeconds(0);
    firstDayOfWeek.setMilliseconds(0);
    let eventsToCreate: any[] = [];
    let remappedDays = JSON.parse(JSON.stringify(this.workDays)).map(
      (shift: any) => {
        shift.startTimeNumber =
          parseInt(shift.timeStart.split(':')[0]) +
          parseInt(shift.timeStart.split(':')[1]) / 60;
        shift.endTimeNumber =
          parseInt(shift.timeEnd.split(':')[0]) +
          parseInt(shift.timeEnd.split(':')[1]) / 60;
        return shift;
      },
    );
    let remappedEvents = JSON.parse(JSON.stringify(this.arrayEvents)).map(
      (shift: any) => {
        shift.startTimeNumber =
          parseInt(shift.startTime.split(':')[0]) +
          parseInt(shift.startTime.split(':')[1]) / 60;
        shift.endTimeNumber =
          parseInt(shift.endTime.split(':')[0]) +
          parseInt(shift.endTime.split(':')[1]) / 60;
        return shift;
      },
    );
    let totalHoursRemainedToUse = 0;
    let totalEmployeeToFix = 0;
    this.employees.forEach((employee: any, employeeIndex) => {
      if (parseFloat(employee.maxWeekHours) > employee.totalWorkedHWeek) {
        let shiftsOfThisEmployee = remappedEvents.filter(
          (event: any) => event.employeeId == employee.id,
        );
        let totalRemainingHours =
          parseFloat(employee.maxWeekHours) - employee.totalWorkedHWeek;
        totalHoursRemainedToUse = totalHoursRemainedToUse + totalRemainingHours;
        totalEmployeeToFix = totalEmployeeToFix + 1;
        if (shiftsOfThisEmployee.length == 0) {
          let indexDay = 0;
          for (let indexTurns = 0; totalRemainingHours > 0; indexTurns++) {
            if (totalRemainingHours > 0) {
              let isShiftFinded = false;
              if (isShiftFinded === false) {
                let findedShiftEmployeeDay = shiftsOfThisEmployee.filter(
                  (shift: any) =>
                    new Date(shift.dateStart).getDay() == indexDay,
                );
                if (!(findedShiftEmployeeDay?.length > 0)) {
                  let dayWork = remappedDays.find(
                    (day: any) => day.day == indexDay,
                  );
                  indexDay = indexDay + 1 == 7 ? 0 : indexDay + 1;
                  let workedSunday = this.employeesWorkedLastSunday.find(
                    (workedEmployee: any) => workedEmployee.id == employee.id,
                  )
                    ? true
                    : false;
                  if (
                    dayWork &&
                    dayWork.day !== 6 &&
                    dayWork.day != employee.freeDay &&
                    (dayWork.day != 0 || employee.canWorkSunday) &&
                    (dayWork.day != 0 || !workedSunday)
                  ) {
                    isShiftFinded = true;
                    let myDay = new Date(
                      new Date(firstDayOfWeek).setDate(
                        new Date(firstDayOfWeek).getDate() +
                          (indexDay == 0 ? 7 : indexDay) -
                          1,
                      ),
                    );
                    if (totalRemainingHours > 8) {
                      totalRemainingHours = totalRemainingHours - 8;
                      if (employee.id == 25) {
                      }
                      eventsToCreate.push({
                        employeeId: employee.id,
                        jobId: employee.jobs[0].id,
                        startTime: dayWork.timeStart,
                        endTime: this.addTimeToMyTime(dayWork.timeStart, 8),
                        date: myDay,
                        storeId: this.selectedStore.id,
                        type: 'CONTINUATO',
                        filledTime: 8,
                      });
                    } else {
                      eventsToCreate.push({
                        employeeId: employee.id,
                        jobId: employee.jobs[0].id,
                        startTime: dayWork.timeStart,
                        endTime: this.addTimeToMyTime(
                          dayWork.timeStart,
                          totalRemainingHours,
                        ),
                        date: myDay,
                        storeId: this.selectedStore.id,
                        type: 'CONTINUATO',
                        filledTime: totalRemainingHours,
                      });
                      totalRemainingHours = 0;
                    }
                  }
                } else {
                  totalRemainingHours = 0;
                }
              }
            } else {
              totalRemainingHours = 0;
            }
          }
        } else {
          let indexDay = 0;
          let indexTurns = 0;
          while (totalRemainingHours > 0 && indexDay < 7 && indexTurns < 99) {
            indexTurns++;
            if (totalRemainingHours > 0) {
              let findedShiftEmployeeDay = shiftsOfThisEmployee.filter(
                (shift: any) => new Date(shift.dateStart).getDay() == indexDay,
              );

              if (findedShiftEmployeeDay == 0) {
                let dayWork = remappedDays.find(
                  (day: any) => day.day == indexDay,
                );

                let durationDay =
                  dayWork.endTimeNumber - dayWork.startTimeNumber;
                let myDay = new Date(
                  new Date(firstDayOfWeek).setDate(
                    new Date(firstDayOfWeek).getDate() +
                      (indexDay == 0 ? 7 : indexDay) -
                      1,
                  ),
                );
                indexDay = indexDay + 1 == 7 ? 0 : indexDay + 1;
                let workedSunday = this.employeesWorkedLastSunday.find(
                  (workedEmployee: any) => workedEmployee.id == employee.id,
                )
                  ? true
                  : false;
                dayWork.day != 0 || !workedSunday;
                if (
                  dayWork &&
                  dayWork.day !== 6 &&
                  dayWork.day != employee.freeDay &&
                  (dayWork.day != 0 || employee.canWorkSunday) &&
                  (dayWork.day != 0 || !workedSunday)
                ) {
                  if (findedShiftEmployeeDay.length == 0) {
                    let durationShift =
                      durationDay >=
                      (totalRemainingHours > 8 ? 8 : totalRemainingHours)
                        ? totalRemainingHours > 8
                          ? 8
                          : totalRemainingHours
                        : durationDay;
                    totalRemainingHours = totalRemainingHours - durationShift;
                    eventsToCreate.push({
                      employeeId: employee.id,
                      jobId: employee.jobs[0].id,
                      startTime: dayWork.timeStart,
                      endTime: this.addTimeToMyTime(
                        dayWork.timeStart,
                        durationShift,
                      ),
                      date: myDay,
                      storeId: this.selectedStore.id,
                      type: 'CONTINUATO',
                      filledTime: durationShift,
                    });
                  }
                } else {
                }
              } else {
                if (findedShiftEmployeeDay.length == 1) {
                  if (
                    findedShiftEmployeeDay[0].endTimeNumber -
                      findedShiftEmployeeDay[0].startTimeNumber <
                    parseFloat(employee.maxDayHours)
                  ) {
                    let dayEvent = new Date(
                      findedShiftEmployeeDay[0].date,
                    ).getDay();
                    let remainingHoursEmployeeToday =
                      parseFloat(employee.maxDayHours) -
                      (findedShiftEmployeeDay[0].endTimeNumber -
                        findedShiftEmployeeDay[0].startTimeNumber);
                    let hRemainedFromStart =
                      findedShiftEmployeeDay[0].startTimeNumber -
                      (this.workDays[dayEvent].openH +
                        this.workDays[dayEvent].openM / 60);
                    let hRemainedFromEnd =
                      this.workDays[dayEvent].closeH +
                      this.workDays[dayEvent].closeM / 60 -
                      findedShiftEmployeeDay[0].endTimeNumber;
                    if (
                      remainingHoursEmployeeToday > 0 &&
                      hRemainedFromStart > 0 &&
                      totalRemainingHours > 0
                    ) {
                      let durationShiftToExtendForFilling =
                        totalRemainingHours < hRemainedFromStart
                          ? totalRemainingHours
                          : hRemainedFromStart;
                      if (
                        durationShiftToExtendForFilling >
                        remainingHoursEmployeeToday
                      ) {
                        durationShiftToExtendForFilling =
                          remainingHoursEmployeeToday;
                      }
                      totalRemainingHours =
                        totalRemainingHours - durationShiftToExtendForFilling;
                      eventsToCreate.push({
                        employeeId: employee.id,
                        jobId: employee.jobs[0].id,
                        startTime: this.workDays[dayEvent].timeStart,
                        endTime: this.addTimeToMyTime(
                          this.workDays[dayEvent].timeStart,
                          durationShiftToExtendForFilling,
                        ),
                        date: findedShiftEmployeeDay[0].date,
                        storeId: this.selectedStore.id,
                        type: 'CONTINUATO',
                        filledTime: durationShiftToExtendForFilling,
                      });
                    }
                    if (
                      remainingHoursEmployeeToday > 0 &&
                      hRemainedFromEnd > 0 &&
                      totalRemainingHours > 0
                    ) {
                      let durationShiftToExtendForFilling =
                        totalRemainingHours < hRemainedFromEnd
                          ? totalRemainingHours
                          : hRemainedFromEnd;
                      totalRemainingHours =
                        totalRemainingHours - durationShiftToExtendForFilling;
                      eventsToCreate.push({
                        employeeId: employee.id,
                        jobId: employee.jobs[0].id,
                        startTime: findedShiftEmployeeDay[0].endTime,
                        endTime: this.addTimeToMyTime(
                          findedShiftEmployeeDay[0].endTime,
                          durationShiftToExtendForFilling,
                        ),
                        date: findedShiftEmployeeDay[0].date,
                        storeId: this.selectedStore.id,
                        type: 'CONTINUATO',
                        filledTime: durationShiftToExtendForFilling,
                      });
                    }
                  } else {
                  }
                } else {
                }
                indexDay = indexDay + 1;
              }
            } else {
              totalRemainingHours = 0;
            }
          }
        }
      }
    });
    if (eventsToCreate.find((evToC: any) => evToC.employeeId == 25)) {
      console.log(
        'Eventi da creare per riempire il calendario',
        eventsToCreate,
      );
    }
    eventsToCreate.forEach((eventToCreate: any) => {
      this.loader.on();
      this.rest.post('/shift', eventToCreate).subscribe({
        next: (value) => {
          this.loader.off(true);
          if (this.loader.loaderCounter == 0) {
            this.getCalendarEvents();
            // window.location.reload()
          }
        },
        error: (err) => {
          this.loader.off(true);
          if (this.loader.loaderCounter == 0) {
            this.getCalendarEvents();
            // window.location.reload()
          }
        },
      });
    });
  }

  // mergeEventsToCreate() {
  //   if (
  //     this.indexCheckEventsFilling + 1 <
  //     this.eventsToCreateForFilling.length
  //   ) {
  //     if (
  //       this.eventsToCreateForFilling[this.indexCheckEventsFilling].endTime ==
  //         this.eventsToCreateForFilling[this.indexCheckEventsFilling + 1]
  //           .startTime &&
  //       this.eventsToCreateForFilling[this.indexCheckEventsFilling]
  //         .employeeId ==
  //         this.eventsToCreateForFilling[this.indexCheckEventsFilling + 1]
  //           .employeeId
  //     ) {
  //       this.eventsToCreateForFilling[this.indexCheckEventsFilling].endTime =
  //         this.eventsToCreateForFilling[
  //           this.indexCheckEventsFilling + 1
  //         ].endTime;
  //       this.eventsToCreateForFilling.splice(
  //         this.indexCheckEventsFilling + 1,
  //         1,
  //       );
  //       this.mergeEventsToCreate();
  //     } else {
  //       this.indexCheckEventsFilling = this.indexCheckEventsFilling + 1;
  //       this.mergeEventsToCreate();
  //     }
  //   } else {
  //     this.createAllEventsForFilling();
  //   }
  // }

  createAllEventsForFilling() {
    this.eventsToCreateForFilling.forEach((eventToCreate: any) => {
      this.loader.on();
      this.rest.post('/shift', eventToCreate).subscribe({
        next: (value) => {
          this.loader.off(true);
          if (this.loader.loaderCounter == 0) {
            this.getCalendarEvents();
          }
        },
        error: (err) => {
          console.log(eventToCreate);
        },
      });
    });
  }

  loopCreateAllSuggestion() {
    if (this.isCalendarCreatingHard) {
      this.alerts = this.alerts.filter((alert: any) => alert.type !== 5);
    } else {
      this.alerts = this.alerts.filter((alert: any) => alert.type == 5);
    }
    if (this.isCalendarCreatingRemainingTurns) {
      this.alerts = this.specialAlerts;
    }
    this.loopDuration = this.alerts.length;
    this.completedHardEvents = 0;
    this.loopIndex = 0;
    this.completeListOfEventsToCreate = [];

    this.createSuggestion(this.alerts[0], true);
  }

  tentativiCreateSuggestion = 0;

  createSuggestion(alert: any, isCreateCalendar?: boolean) {
    if (alert?.jobName && alert.type == 1) {
      let listEmployees = this.employees.filter((employee: any) => {
        let conditionHours =
          employee.maxDayHours - employee['totalHWorked' + alert.day] > 0;
        let conditionSameJob = employee.jobs.find(
          (job: any) => job.id == alert.jobId,
        );
        let workedSunday = this.employeesWorkedLastSunday.find(
          (workedEmployee: any) => workedEmployee.id == employee.id,
        )
          ? true
          : false;
        if (workedSunday && !employee.freeDay) {
          employee.freeDay = this.lastFreeDay;
          this.lastFreeDay = this.lastFreeDay + 1;
          if (this.lastFreeDay == 7) {
            this.lastFreeDay = 1;
          }
        }
        let randomFreeDay = employee.freeDay;
        // console.log(randomFreeDay);
        let totalWorkedHWeek = 0;
        for (let index = 0; index < 7; index++) {
          totalWorkedHWeek =
            totalWorkedHWeek + (employee['totalHWorked' + index] ?? 0);
        }
        let conditionMaxWeekHours =
          totalWorkedHWeek < parseFloat(employee.maxWeekHours);
        let conditionWorkedSunday = workedSunday
          ? alert.day !== randomFreeDay && alert.day !== 0
          : true;
        let conditionFreeOtherDays = false;
        let alreadyWorked = this.completeListOfEventsToCreate.find(
          (workEvent: any) =>
            workEvent.employeeId == employee.id &&
            new Date(workEvent.date).getDay() == alert.day &&
            workEvent.startTime ==
              this.addTimeToMyTime(`${alert.h}:${alert.m}:00`, 0),
        );
        return (
          alert.day != employee.freeDay &&
          !alreadyWorked &&
          (employee.canWorkSunday ? true : alert.day != 0) &&
          conditionSameJob &&
          conditionHours &&
          (conditionWorkedSunday || conditionFreeOtherDays)
        );
      });
      listEmployees.map((employee: any) => {
        let jobIndex = employee.jobs.findIndex(
          (job: any) => job.id == alert.jobId,
        );
        employee.jobPriority = jobIndex;
        if (jobIndex > 0) {
        }
        return employee;
      });
      listEmployees.sort((a, b) => a.jobPriority - b.jobPriority);

      let myAlert = JSON.parse(JSON.stringify(alert));
      let totalAvailableHours = 0;

      listEmployees.forEach((employee, index) => {
        let totalWorkedH = 0;
        for (let index = 0; index < 7; index++) {
          totalWorkedH = totalWorkedH + (employee['totalHWorked' + index] ?? 0);
        }

        totalAvailableHours =
          totalAvailableHours +
          (employee.maxDayHours - employee['totalHWorked' + alert.day] >
          totalWorkedH - employee.maxWeekHours
            ? employee.maxDayHours - employee['totalHWorked' + alert.day]
            : totalWorkedH - employee.maxWeekHours);
        if (
          employee.maxDayHours - employee['totalHWorked' + alert.day] >
          parseFloat(employee.maxWeekHours) - totalWorkedH
        ) {
          listEmployees[index].availableHoursToday =
            parseFloat(employee.maxWeekHours) - totalWorkedH;
        } else {
          listEmployees[index].availableHoursToday =
            employee.maxDayHours - employee['totalHWorked' + alert.day];
        }
      });

      let endInH = alert.endH + alert.endM / 60;
      let startInH = alert.h + alert.m / 60;
      let toFillTime = endInH - startInH;
      if (true) {
        let eventsToCreate: any[] = [];
        let filledTime = 0;
        listEmployees.forEach((employee: any) => {
          let totalWorkedH = 0;
          for (let index = 0; index < 7; index++) {
            totalWorkedH =
              totalWorkedH + (employee['totalHWorked' + index] ?? 0);
          }
          let alreadyWorkedThisHours = this.completeListOfEventsToCreate.find(
            (eventToCreate: any) => {
              let checkEmployee = eventToCreate.employeeId == employee.id;
              return (
                this.addTimeToMyTime(
                  `${myAlert.h}:${myAlert.m}:00`,
                  filledTime,
                ) == eventToCreate.startTime &&
                alert.day == eventToCreate.date.getDay() &&
                checkEmployee
              );
            },
          );
          if (
            !alreadyWorkedThisHours &&
            toFillTime > 0 &&
            employee.availableHoursToday > 0 &&
            totalWorkedH < employee.maxWeekHours
          ) {
            // let randomStart = Math.floor(Math.random() * 3) + 2
            let maxTimeForTurn = 8; // PER FORZA!!! cosi da decidere quanto durare i turni quel giorno
            let timeToAdd = 4;
            if (toFillTime - timeToAdd < 4) {
              timeToAdd = toFillTime;
            }
            if (timeToAdd < 4) {
              timeToAdd = 4;
            }
            this.employees[
              this.employees.findIndex((res: any) => res.id == employee.id)
            ]['totalHWorked' + alert.day] =
              this.employees[
                this.employees.findIndex((res: any) => res.id == employee.id)
              ]['totalHWorked' + alert.day] + timeToAdd;
            eventsToCreate.push({
              employeeId: employee.id,
              jobId: alert.jobId,
              startTime: this.addTimeToMyTime(
                `${myAlert.h}:${myAlert.m}:00`,
                filledTime,
              ),
              endTime: this.addTimeToMyTime(
                `${myAlert.h}:${myAlert.m}:00`,
                filledTime + timeToAdd,
              ),
              date: new Date(alert.date),
              storeId: this.selectedStore.id,
              type: 'CONTINUATO',
              filledTime:
                employee.availableHoursToday > toFillTime
                  ? toFillTime
                  : employee.availableHoursToday,
            });
            this.completeListOfEventsToCreate.push({
              employeeId: employee.id,
              jobId: alert.jobId,
              startTime: this.addTimeToMyTime(
                `${myAlert.h}:${myAlert.m}:00`,
                filledTime,
              ),
              endTime: this.addTimeToMyTime(
                `${myAlert.h}:${myAlert.m}:00`,
                filledTime + timeToAdd,
              ),
              date: new Date(alert.date),
              storeId: this.selectedStore.id,
              type: 'CONTINUATO',
              filledTime:
                employee.availableHoursToday > toFillTime
                  ? toFillTime
                  : employee.availableHoursToday,
            });
            filledTime = filledTime + timeToAdd;
            toFillTime = toFillTime - timeToAdd;

            if (isCreateCalendar && this.loopDuration > this.loopIndex) {
              this.loopIndex = this.loopIndex + 1;
              this.createSuggestion(this.alerts[this.loopIndex], true);
            }
          } else {
            if (isCreateCalendar && this.loopDuration > this.loopIndex) {
              this.loopIndex = this.loopIndex + 1;
              this.createSuggestion(this.alerts[this.loopIndex], true);
            }
          }
        });
        listEmployees.forEach((employee: any) => {
          let totalWorkedH = 0;
          for (let index = 0; index < 7; index++) {
            totalWorkedH =
              totalWorkedH + (employee['totalHWorked' + index] ?? 0);
          }
          // if(employee.id == 25){
            
          //   let alreadyWorekedThisDay = this.completeListOfEventsToCreate.filter(
          //     (eventToCreate: any) => {
          //       let checkEmployee = eventToCreate.employeeId == employee.id;
          //       return checkEmployee && alert.day == eventToCreate.date.getDay();
          //     },
          //   );
          //   console.log('alreadyWorekedThisHours', alreadyWorekedThisDay,employee,employee.availableHoursToday);
          // }
          if (
            employee['totalHWorked' + alert.day] < (parseFloat(employee.maxDayHours) -1) &&
            toFillTime > 0 &&
            employee.availableHoursToday > 0 &&
            totalWorkedH < employee.maxWeekHours
          ) {
            // let randomStart = Math.floor(Math.random() * 3) + 2
            let maxTimeForTurn = 8; // PER FORZA!!! cosi da decidere quanto durare i turni quel giorno
            let timeToAdd = 4;
            if (toFillTime - timeToAdd < 4) {
              timeToAdd = toFillTime;
            }
            if (timeToAdd < 4) {
              timeToAdd = 4;
            }
            this.employees[
              this.employees.findIndex((res: any) => res.id == employee.id)
            ]['totalHWorked' + alert.day] =
              this.employees[
                this.employees.findIndex((res: any) => res.id == employee.id)
              ]['totalHWorked' + alert.day] + timeToAdd;
            eventsToCreate.push({
              employeeId: employee.id,
              jobId: alert.jobId,
              startTime: this.addTimeToMyTime(
                `${myAlert.h}:${myAlert.m}:00`,
                filledTime,
              ),
              endTime: this.addTimeToMyTime(
                `${myAlert.h}:${myAlert.m}:00`,
                filledTime + timeToAdd,
              ),
              date: new Date(alert.date),
              storeId: this.selectedStore.id,
              type: 'CONTINUATO',
              filledTime:
                employee.availableHoursToday > toFillTime
                  ? toFillTime
                  : employee.availableHoursToday,
            });
            this.completeListOfEventsToCreate.push({
              employeeId: employee.id,
              jobId: alert.jobId,
              startTime: this.addTimeToMyTime(
                `${myAlert.h}:${myAlert.m}:00`,
                filledTime,
              ),
              endTime: this.addTimeToMyTime(
                `${myAlert.h}:${myAlert.m}:00`,
                filledTime + timeToAdd,
              ),
              date: new Date(alert.date),
              storeId: this.selectedStore.id,
              type: 'CONTINUATO',
              filledTime:
                employee.availableHoursToday > toFillTime
                  ? toFillTime
                  : employee.availableHoursToday,
            });
            filledTime = filledTime + timeToAdd;
            toFillTime = toFillTime - timeToAdd;
            if (isCreateCalendar && this.loopDuration > this.loopIndex) {
              this.loopIndex = this.loopIndex + 1;
              this.createSuggestion(this.alerts[this.loopIndex], true);
            }
          }
        });
        let doneEvent = 0;
        if (eventsToCreate.length == 0) {
          if (doneEvent == eventsToCreate.length && isCreateCalendar) {
            this.completedAlert = this.completedAlert + 1;
            if (this.completedAlert == this.alerts.length) {
              this.completedAlert = 0;
              this.getCalendarEvents();
            } else {
              this.loopIndex = this.loopIndex + 1;
              this.createSuggestion(this.alerts[this.loopIndex], true);
            }
          }
        }
        if (eventsToCreate.find((evToC: any) => evToC.employeeId == 25)) {
          console.log(
            'Eventi da creare per creazione iniziale del calendario',
            eventsToCreate,
          );
        }
        eventsToCreate.forEach((eventToCreate: any) => {
          this.loader.on();
          this.rest.post('/shift', eventToCreate).subscribe({
            next: (value) => {
              this.loader.off(true);
              doneEvent = doneEvent + 1;
              if (doneEvent == eventsToCreate.length && !isCreateCalendar) {
                //Fine creazione suggerimento singolo
                this.getCalendarEvents();
              }
              if (
                doneEvent == eventsToCreate.length &&
                this.isCalendarCreatingRemainingTurns
              ) {
                if (this.isCalendarCreatingR2) {
                  this.isCalendarCreatingRemainingTurns = false;
                  this.isCalendarCreatingR2 = false;
                  this.alerts = [];
                  this.specialAlerts = [];
                  this.arrayEvents = [];
                  this.isCalendarCreating = false;
                  this.isCalendarCreatingHard = false;
                  setTimeout(() => {
                    this.getCalendarEvents();
                  }, 100);
                } else {
                  this.isCalendarCreatingR2 = true;
                  this.getCalendarEvents();
                }
              }
              if (doneEvent == eventsToCreate.length && isCreateCalendar) {
                this.completedAlert = this.completedAlert + 1;
                if (this.completedAlert == this.alerts.length) {
                  this.completedAlert = 0;
                  this.getCalendarEvents();
                }
              }
            },
            error: (err) => {
              console.log(eventToCreate);
            },
          });
        });
        if (eventsToCreate.length == 0) {
          doneEvent = doneEvent + 1;
          if (doneEvent == eventsToCreate.length && !isCreateCalendar) {
            //Fine creazione suggerimento singolo
            this.getCalendarEvents();
          }
          if (
            doneEvent == eventsToCreate.length &&
            this.isCalendarCreatingRemainingTurns
          ) {
            if (this.isCalendarCreatingR2) {
              this.isCalendarCreatingRemainingTurns = false;
              this.isCalendarCreatingR2 = false;
              this.alerts = [];
              this.specialAlerts = [];
              this.arrayEvents = [];
              this.isCalendarCreating = false;
              this.isCalendarCreatingHard = false;
              setTimeout(() => {
                this.getCalendarEvents();
              }, 100);
            } else {
              this.isCalendarCreatingR2 = true;
              this.getCalendarEvents();
            }
          }
          if (doneEvent == eventsToCreate.length && isCreateCalendar) {
            this.completedAlert = this.completedAlert + 1;
            if (this.completedAlert == this.alerts.length) {
              this.completedAlert = 0;
              this.getCalendarEvents();
            }
          }
        }
      } else {
        this.loopIndex = this.loopIndex + 1;
        this.createSuggestion(this.alerts[this.loopIndex], true);
        this.completedAlert = this.completedAlert + 1;
        if (this.completedAlert + 1 == this.alerts.length && isCreateCalendar) {
          this.completedAlert = 0;
          this.getCalendarEvents();
        }
        // this.message.showMessage("Non c'è abbastanza personale per coprire questo turno", 'error')
      }
    } else {
      if (alert?.missingNumber && alert.type == 5) {
        let listEmployees = this.employees.filter((employee: any) => {
          let conditionHours =
            employee.maxDayHours - employee['totalHWorked' + alert.day] > 0;
          let conditionSameJob = employee.jobs.find((job: any) =>
            job.jobType.includes('hard'),
          );
          let workedSunday = this.employeesWorkedLastSunday.find(
            (workedEmployee: any) => workedEmployee.id == employee.id,
          )
            ? true
            : false;
          if (workedSunday && !employee.freeDay) {
            employee.freeDay = this.lastFreeDay;
            this.lastFreeDay = this.lastFreeDay + 1;
            if (this.lastFreeDay == 7) {
              this.lastFreeDay = 1;
            }
          }
          let randomFreeDay = employee.freeDay;
          let conditionWorkedSunday = workedSunday
            ? alert.day !== randomFreeDay && alert.day !== 0
            : true;
          let conditionFreeOtherDays = false;
          let workdedToday = this.arrayEvents.filter((event: any) => {
            return (
              new Date(event.dateStart).getDay() == alert.day &&
              employee.id == event.employeeId
            );
          });
          return (
            alert.day != employee.freeDay &&
            conditionSameJob &&
            !workdedToday?.length &&
            conditionHours &&
            (alert.day != 0 || employee.canWorkSunday) &&
            (conditionWorkedSunday || conditionFreeOtherDays)
          );
        });

        if (listEmployees.length >= alert.missingNumber) {
          let doneEventThisAlert = 0;
          for (let indexEmp = 0; indexEmp < alert.missingNumber; indexEmp++) {
            let myAlert = alert;
            let filledTime =
              alert.endH + alert.endM / 60 - (alert.h + alert.m / 60);
            // if(filledTime < 4){
            //   filledTime = 4
            // }
            let jobToSelect = listEmployees[indexEmp].jobs.find((myJob: any) =>
              myJob.jobType.includes('hard'),
            );
            let eventToCreate = {
              employeeId: listEmployees[indexEmp].id,
              jobId: jobToSelect.id,
              startTime: this.addTimeToMyTime(
                `${myAlert.h}:${myAlert.m}:00`,
                0,
              ),
              endTime: this.addTimeToMyTime(
                `${myAlert.h}:${myAlert.m}:00`,
                filledTime,
              ),
              date: new Date(alert.date),
              storeId: this.selectedStore.id,
              type: 'CONTINUATO',
              filledTime: filledTime,
            };
            this.rest.post('/shift', eventToCreate).subscribe({
              next: (value) => {
                this.loader.off(true);
                doneEventThisAlert = doneEventThisAlert + 1;

                if (doneEventThisAlert == alert.missingNumber) {
                  this.completedHardEvents = this.completedHardEvents + 1;
                }
                if (this.completedHardEvents == this.alerts.length) {
                  this.completedHardEvents = 0;
                  this.creatingRemainingHours = true;
                  this.getCalendarEvents();
                }
              },
              error: (err) => {
                this.loader.off(true);
                doneEventThisAlert = doneEventThisAlert + 1;
                if (doneEventThisAlert == alert.missingNumber) {
                  this.completedHardEvents = this.completedHardEvents + 1;
                }
                if (this.completedHardEvents == this.alerts.length) {
                  this.completedHardEvents = 0;
                  this.creatingRemainingHours = true;
                  this.getCalendarEvents();
                }
              },
            });
          }
        } else {
          this.completedHardEvents = this.completedHardEvents + 1;
          this.message.showMessage(
            `Non c'è abbastanza personale per fascia alta ${this.translateDay(alert.day)} ${alert.h}:${alert.m} - ${alert.endH}:${alert.endM}`,
            'error',
          );
          if (this.completedHardEvents == this.alerts.length) {
            this.completedHardEvents = 0;
            this.creatingRemainingHours = true;
            this.getCalendarEvents();
          }
        }
        this.loopIndex = this.loopIndex + 1;
        this.createSuggestion(this.alerts[this.loopIndex], true);
      } else {
        if (isCreateCalendar && this.loopDuration > this.loopIndex) {
          this.loopIndex = this.loopIndex + 1;
          this.createSuggestion(this.alerts[this.loopIndex], true);
        }
      }
    }
  }

  translateDay(day: number) {
    switch (day) {
      case 1:
        return 'Lunedi';
      case 2:
        return 'Martedi';
      case 3:
        return 'Mercoledi';
      case 4:
        return 'Giovedi';
      case 5:
        return 'Venerdi';
      case 6:
        return 'Sabato';
      case 0:
        return 'Domenica';

      default:
        return 'Lunedi';
        break;
    }
  }

  createCalendar() {
    //Crea tutto il calendario della settimana usando i suggerimenti creati
    this.showModalCreateCalendar = false;
    this.loader.on();
    this.rest
      .delete(
        `/shift/range?storeId=${this.selectedStore.id}&startDate=${this.calendarStart}&endDate=${this.calendarEnd}&jobType=${JSON.stringify(this.workingJobs)}`,
      )
      .subscribe({
        next: (value) => {
          this.isCalendarCreating = true;
          this.getCalendarEvents();
        },
      });
  }

  deleteEvent(id: string) {
    this.loader.on();
    this.rest.delete(`/shift/` + id).subscribe({
      next: (value) => {
        this.loader.off();
        this.showModalEventDelete = false;
        this.showModalEvent = false;
        // this.currentEventSelected = {}
        this.getCalendarEvents();
      },
    });
  }

  isShiftValid(shift: any) {}

  deleteAllCalendar() {
    this.loader.on();
    this.rest
      .delete(
        `/shift/range?storeId=${this.selectedStore.id}&startDate=${this.calendarStart}&endDate=${this.calendarEnd}&jobType=${JSON.stringify(this.workingJobs)}`,
      )
      .subscribe({
        next: (value) => {
          this.loader.off();
          this.getCalendarEvents();
        },
      });
  }

  addTimeToMyTime(time: string, hoursToAdd: number) {
    let elements = time.split(':');
    let myHours = parseInt(elements[0]);
    let myMinutes = parseInt(elements[1]);
    let mySecond = parseInt(elements[2]);
    let isInt = hoursToAdd % 1 == 0;
    let isMin30 = myMinutes == 30;
    let newHours =
      myHours +
      (!isInt && isMin30
        ? parseInt(hoursToAdd.toString()) + 1
        : parseInt(hoursToAdd.toString()));
    let newMinutes =
      (!isInt ? 1 : 0) + (isMin30 ? 1 : 0) == 0 ||
      (!isInt ? 1 : 0) + (isMin30 ? 1 : 0) == 2
        ? '00'
        : '30';
    let newSeconds = '00';
    return `${newHours}:${newMinutes}:${newSeconds}`;
  }
}
